import React, {useEffect, useState} from 'react';
import styles from './navbar.module.scss'
import {LinkProps, NavLink, useNavigate} from 'react-router-dom'
import {auth} from "../../store/redusers/authSlice";
import {useAuth} from "../../hooks/auth.hook";
import {useAppDispatch, useAppSelector} from "../../store/store";
import {AppRoutes, routeConfig, RouteLabel} from "../../app/routeConfig";
import {Menu} from 'antd';
import type {MenuProps} from 'antd';
import MenuIcon from "../UI/menuIcon/MenuIcon";
import logoImg from "../../assets/images/logo-img.png";
import languages from '../../assets/images/languages.png'
import {Languages} from "../../shared/types";
import {useTranslation} from 'react-i18next';
import Loader from "../UI/loader/Loader";

const Navbar = () => {

  const {t, i18n} = useTranslation();
  const lang = i18n.language as Languages

  const dispatch = useAppDispatch()
  const navigate = useNavigate();

  const userIdInStore = useAppSelector(state => state.authReduser.userId)
  const tokenInStore = useAppSelector(state => state.authReduser.token)
  const isLoading = useAppSelector(state => state.loaderReduser.isLoading)

  const [isAuth, setIsAuth] = useState(false)
  const [activeLink, setActiveLink] = useState<AppRoutes | undefined>()

  const {login, logout, token, userId, ready} = useAuth()

  useEffect(() => {
    if (token && userId && ready) {
      setIsAuth(true)
    }
  }, [token, userId, ready])

  useEffect(() => {
    if (userIdInStore && tokenInStore) {
      setIsAuth(true)
    } else {
      setIsAuth(false)
    }
  }, [userIdInStore, tokenInStore])

  useEffect(() => {
    if (isAuth) {
      setActiveLink(AppRoutes.MAIN)
    } else {
      setActiveLink(AppRoutes.LOGIN)
    }
  }, [isAuth])

  const onQuit = () => {
    logout()
    dispatch(auth({userId: null, token: null}))
    setIsAuth(false)
  }

  type MenuItem = Required<MenuProps>['items'][number];
  const [current, setCurrent] = useState('');
  const items: MenuItem[] = [
    {
      label: '',
      key: 'SubMenu',
      icon: <MenuIcon/>,
      children: [
        {
          type: 'group',
          children: [
            {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.MAIN_TITLE]),
              key: AppRoutes.MAIN_TITLE
            },
            !isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.LOGIN]),
              key: AppRoutes.LOGIN
            } : null,
            !isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.REGISTRATION]),
              key: AppRoutes.REGISTRATION
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.MAIN]),
              key: AppRoutes.MAIN
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.STRATEGIES]),
              key: AppRoutes.STRATEGIES
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.POSITIONS]),
              key: AppRoutes.POSITIONS
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.RATINGS]),
              key: AppRoutes.RATINGS
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.TESTING]),
              key: AppRoutes.TESTING
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.SIMULATED_TRANSACTION]),
              key: AppRoutes.SIMULATED_TRANSACTION
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.INVESTING_TIP]),
              key: AppRoutes.INVESTING_TIP
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t(RouteLabel[AppRoutes.EMAIL_PARSING]),
              key: AppRoutes.EMAIL_PARSING
            } : null,
            isAuth ? {
              //@ts-ignore
              label: t('MenuExit'),
              key: 'exit'
            } : null,
          ],
        },
      ],
    },
  ];

  const onClickMenu: MenuProps['onClick'] = (e) => {
    const key = e.key as keyof typeof routeConfig | 'exit'
    if (key !== 'exit') {
      navigate(routeConfig[key].routeProps.path as LinkProps['to']);
    } else if (key === 'exit') {
      onQuit()
    }
  };

  //изменение языка сайта по клику по переключателю
  const languageHandler = () => {
    const language = lang
    if (language === 'en') {
      i18n.changeLanguage('ru')
    } else if (language === 'ru') {
      i18n.changeLanguage('en')
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={[styles.main, activeLink === AppRoutes.MAIN ? styles.activeLink : ''].join(' ')}>
          <NavLink onClick={() => {
            setActiveLink(AppRoutes.MAIN_TITLE)
          }}
                   to={routeConfig[AppRoutes.MAIN_TITLE].routeProps.path as LinkProps['to']}>
            <h1 className={styles.header}><img src={logoImg} alt="Invest Helper"/></h1>
          </NavLink>
        </div>
        <div className={styles.right}>
          <Loader loading={isLoading}/>
          <div className={[styles.languages, styles[lang]].join(' ')} onClick={languageHandler}>
            <img src={languages} alt=""/>
          </div>
          <Menu selectedKeys={[current]} onClick={onClickMenu} mode="horizontal" items={items}
                style={{minWidth: 55, marginTop: '-8px', marginRight: '-12px'}}/>
        </div>
      </div>
    </div>
  );
};

export default Navbar;